import * as React from "react";
const SvgBigGreenCurrency = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <path
      stroke="#389C7B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M18 31.89c7.672 0 13.89-6.219 13.89-13.89S25.672 4.11 18 4.11C10.33 4.11 4.11 10.329 4.11 18S10.33 31.89 18 31.89"
    />
    <path
      stroke="#389C7B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M16.97 19.5c-.938 2.188-2.344 4.375-4.219 5.25h8.906s1.407 0 2.344-.875m-3.75-4.375h-8.25m10.5-4.125a4.125 4.125 0 1 0-4.125 4.125"
    />
  </svg>
);
export default SvgBigGreenCurrency;
